import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, Dropdown, Button, Badge, Offcanvas } from 'react-bootstrap';
import { fetchCurrentUser, logout } from '../../API';
import { IoPersonCircle } from "react-icons/io5";
import { GoGear } from "react-icons/go";
import { TbLogout2 } from "react-icons/tb";
import { MdHistory } from "react-icons/md";

export default function NavigationBar() {
    const [user, setUser] = useState({ logged: false });
    // Dodajemy stan do zarządzania otwarciem menu (Offcanvas)
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const userData = await fetchCurrentUser();
            setUser(userData);
        };
        checkAuth();
    }, []);

    // Pomocnicza funkcja zamykająca menu
    const closeMenu = () => setExpanded(false);

    return (
        <Navbar 
            expanded={expanded} // Kontrolowanie stanu otwarcia
            onToggle={(isExpanded) => setExpanded(isExpanded)} // Aktualizacja po kliknięciu w hamburger lub kliknięciu poza
            sticky="top" 
            expand="lg" 
            className="shadow-sm" 
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(10px)' }}
        >
            <Container fluid className="px-4 py-1">
                {/* Logo - dodano onClick do zamykania menu, gdy ktoś kliknie w logo na otwartym panelu */}
                <Navbar.Brand as={Link} to="/" onClick={closeMenu} className="d-flex align-items-center gap-2 fw-bold text-dark fs-5">
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="24" 
                        height="16" 
                        viewBox="0 0 300 200" 
                        className="rounded shadow-sm"
                    >
                        <rect width="300" height="200" fill="#FFCE00"/>
                        <rect width="300" height="133.3" fill="#DD0000"/>
                        <rect width="300" height="66.6" fill="#000000"/>
                    </svg>
                    Lern Deutsch
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />

                <Navbar.Offcanvas
                    id="offcanvasNavbar-expand-lg"
                    aria-labelledby="offcanvasNavbarLabel-expand-lg"
                    placement="start"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg" className="fw-bold d-flex align-items-center gap-2">
                            Menu
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    
                    <Offcanvas.Body>
                        <Nav className="ms-auto align-items-start align-items-lg-center gap-lg-4 gap-3 py-3 py-lg-0 w-100 justify-content-end">
                            {/* Dodano onClick={closeMenu} do wszystkich klikalnych elementów */}
                            <Nav.Link as={Link} to="/crossword-config" onClick={closeMenu} className="text-secondary fw-medium">
                                Krzyżówki
                            </Nav.Link>
                            <Nav.Link as={Link} to="/wordsearch-config" onClick={closeMenu} className="text-secondary fw-medium">
                                Wykreślanki
                            </Nav.Link>
                            
                            

                            <Nav.Link as={Link} to="/ranking" onClick={closeMenu} className="text-secondary fw-medium">
                                Sala chwały
                            </Nav.Link>

                            <div className="ms-lg-2 mt-3 mt-lg-0">
                                {!user.logged ? (
                                    <Button as={Link} to="/login" onClick={closeMenu} variant="primary" className="fw-semibold px-4 rounded-3 d-flex align-items-center gap-2">
                                        Zaloguj się
                                    </Button>
                                ) : (
                                    <Dropdown align="end">
                                        <Dropdown.Toggle 
                                            variant="primary" 
                                            id="dropdown-profile" 
                                            className="d-flex align-items-center gap-2 fw-semibold px-3 py-2 border-0 rounded-3 w-100 justify-content-between"
                                        >
                                            <div className="d-flex align-items-center gap-2">
                                                <IoPersonCircle size={24} />
                                                <span className="text-truncate" style={{ maxWidth: '120px' }}>
                                                    {user.name || 'Użytkownik'}
                                                </span>
                                            </div>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="shadow border-0 rounded-3 mt-2" style={{ minWidth: '220px' }}>
                                            <div className="px-3 py-2 bg-light rounded-top-3">
                                                <div className="fw-bold fs-6 text-dark">{user.name}</div>
                                                <div className="text-muted" style={{ fontSize: '13px' }}>{user.email}</div>
                                                <div className="text-warning mt-1 fw-bold" style={{ fontSize: '14px' }}>
                                                    🏆 Punkty: {user.points || 0}
                                                </div>
                                            </div>
                                            <Dropdown.Divider className="m-0 mb-1" />
                                            <Dropdown.Item as={Link} to="/settings" onClick={closeMenu} className="py-2 text-secondary d-flex align-items-center gap-2">
                                                <GoGear size={18} /> Ustawienia
                                            </Dropdown.Item>
                                            <Dropdown.Item as={Link} to="/history" onClick={closeMenu} className="py-2 text-secondary d-flex align-items-center gap-2">
                                                <MdHistory size={18} /> Historia
                                            </Dropdown.Item>
                                            <Dropdown.Item 
                                                onClick={() => {
                                                    logout();
                                                    closeMenu();
                                                }} 
                                                className="py-2 text-danger fw-bold d-flex align-items-center gap-2 mt-1"
                                            >
                                                <TbLogout2 size={18} /> Wyloguj się
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                )}
                            </div>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
}